import type { EventName, EventProps, AnalyticsPayload } from './types';
import { getSessionId } from './session';

// API base URL — env var, fallback на same-origin
const API_BASE: string =
  (import.meta.env.VITE_API_URL as string | undefined) ?? '';

export function track(name: EventName, props: EventProps = {}): void {
  const payload: AnalyticsPayload = {
    event: name,
    props,
    ts: Date.now(),
    session_id: getSessionId(),
  };

  // Fire-and-forget; используем sendBeacon если доступен (выживает unload)
  const url = `${API_BASE}/api/analytics/event`;
  const json = JSON.stringify(payload);

  try {
    if (
      typeof navigator !== 'undefined' &&
      typeof navigator.sendBeacon === 'function'
    ) {
      // text/plain keeps the request "simple" — no CORS preflight is needed
      // since the analytics endpoint runs on a different origin in dev.
      // Backend reads c.req.text() so content-type is irrelevant.
      const blob = new Blob([json], { type: 'text/plain' });
      const sent = navigator.sendBeacon(url, blob);
      if (sent) return;
    }
    void fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body: json,
      keepalive: true,
      credentials: 'omit',
    }).catch(() => {});
  } catch {
    // network unavailable — silently skip
  }
}
